import { FC } from "react";
import { observer } from "mobx-react";
import { Box, Button, InputAdornment } from "@mui/material";

import Row from "../ui/core/Row";
import CoreKeywordSearch from "../ui/core/CoreKeywordSearch";
import { CloseIcon, SearchIcon } from "../icons";
import { useTicketStore } from "../../hooks/useTicketStore";
import TicketColumnVisibilityButton from "./TicketColumnVisibilityButton";

export const TicketsSearchInput: FC = observer(() => {
  const {
    keywordSearch,
    setKeywordSearch,
    hasFiltersApplied,
    clearFilters,
  } = useTicketStore();

  return (
    <Row sx={{ height: "auto", mt: 2, gap: 1, alignItems: "center" }}>
      <Box sx={{ minWidth: "200px", maxWidth: "320px", width: "100%" }}>
        <CoreKeywordSearch
          placeholder="Search tickets"
          value={keywordSearch}
          onChange={setKeywordSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Box sx={{ flex: 1 }} />

      {hasFiltersApplied ? (
        <Button
          variant="text"
          startIcon={<CloseIcon />}
          onClick={() => clearFilters()}
          sx={{ minWidth: "120px", color: "error.dark" }}
        >
          Clear Filters
        </Button>
      ) : null}

      <TicketColumnVisibilityButton />
    </Row>
  );
});

export default TicketsSearchInput;
